<template>
  <exec-report-panel report-name="tiers" title="Membresías y beneficios" :filters="filters" @error="$emit('error', $event)" />
</template>

<script>
import ExecReportPanel from './ExecReportPanel.vue';
// Pestaña 5 · Membresías (doc 04 §3, reporte 6).
export default { name: 'ExecTiers', components: { ExecReportPanel }, props: { filters: { type: Object, default: () => ({}) } } };
</script>
